<p-toast></p-toast>
<app-nav-header></app-nav-header>
<div class="wrapper">
	<div class="main">
		<div id="recruitPage">
			<div class="formArea">
				<div class="formAreaBox">
					<div class="formBox">
						<div class="personBox">
							<p-fieldset
								legend="個人資料設定"
								[toggleable]="true"
							>
								<form
									[formGroup]="buyerForm"
									class="row justify-content-center"
								>
									<div class="form-group d-flex col-12 col-md-8 align-items-center mb-3">
										<label
											class="mb-0"
											style="flex: 1 2.6rem"
										>
											<span class="required">*</span>
											<span>收件姓名</span>
										</label>
										<div
											class="col pr-0 field-cus"
											style="flex: 7"
										>
											<div class="d-flex">
												<input
													pInputText
													type="text"
													placeholder="請輸入收件姓名"
													formControlName="buyerName"
													id="buyerName"
												/>
											</div>
										</div>
									</div>
									<div class="form-group d-flex col-12 col-md-8 align-items-center mb-3">
										<label
											class="mb-0"
											style="flex: 1 2.6rem"
										>
											<span>暱稱(選填)</span>
										</label>
										<div
											class="col pr-0 field-cus"
											style="flex: 7"
										>
											<div class="d-flex">
												<input
													pInputText
													type="text"
													placeholder="請輸入暱稱(Excel表單用)"
													formControlName="buyerNickName"
													id="buyerNickName"
												/>
											</div>
										</div>
									</div>
									<div class="form-group d-flex col-12 col-md-8 align-items-center mb-3">
										<label
											class="mb-0"
											style="flex: 1 2.6rem"
										>
											<span class="required hidden">*</span>
											<span>手機號碼</span>
										</label>
										<div
											class="col pr-0 field-cus"
											style="flex: 7"
										>
											<input
												pInputText
												type="text"
												placeholder="請輸入手機號碼，ex: 0912345678"
												formControlName="buyerPhone"
												id="buyerPhone"
											/>
										</div>
									</div>
									<div class="form-group d-flex col-12 col-md-8 align-items-center mb-3">
										<label
											class="mb-0"
											style="flex: 1 2.6rem"
										>
											<span class="required">*</span>
											<span>匯款帳號</span>
										</label>
										<div
											class="col pr-0 field-cus"
											style="flex: 7"
										>
											<input
												pInputText
												type="text"
												placeholder="請輸入末5碼"
												formControlName="buyerBankAccount"
												id="buyerBankAccount"
											/>
										</div>
									</div>
									<div class="form-group d-flex col-12 col-md-8 align-items-center mb-3">
										<label
											class="mb-0"
											style="flex: 1 2.6rem"
										>
											<span class="required">*</span>
											<span>711店鋪</span>
										</label>
										<div
											class="col pr-0 field-cus"
											style="flex: 7"
										>
											<input
												pInputText
												type="text"
												placeholder="請輸入門市名稱"
												formControlName="711Name"
												id="711Name"
											/>
										</div>
									</div>
								</form>
								<div style="flex: 2">
									<div class="footerBox">
										<button
											class="vacancies-btn"
											(click)="updateProfile()"
										>
											<span>更新資料</span>
										</button>
									</div>
								</div>
							</p-fieldset>
							<p-fieldset
								legend="折扣代碼"
								[toggleable]="true"
							>
								<div class="table-wrapper">
									<p-table [value]="discountCodes">
										<ng-template pTemplate="header">
											<tr>
												<th>折扣代碼</th>
												<th>折扣金額</th>
												<th>備註</th>
											</tr>
										</ng-template>
										<ng-template
											pTemplate="body"
											let-discountCode
										>
											<tr>
												<td>{{ discountCode.discountCode }}</td>
												<td>{{ '$' + discountCode.discountAmount }}</td>
												<td>{{ !!discountCode.memo ? discountCode.memo : '-' }}</td>
											</tr>
										</ng-template>
										<ng-template pTemplate="emptymessage">
											<tr>
												<td colspan="2">目前暫無折扣代碼</td>
											</tr>
										</ng-template>
									</p-table>
								</div>
							</p-fieldset>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<app-footer></app-footer>
<p-overlayPanel #op>
	<img
		src="/bigaunt/assets/images/display-card.png"
		alt="Big Aunt's"
		class="random-notice"
	/>
	<!-- <b>📍玩法規則｜Lucky Wheel 幸運轉盤</b>
	<br />
	<b>ㄧ、每開一張卡，立即使用隨機轉盤轉出該卡得主</b>
	<br />
	<b>二、其中16人，每人將獲得 1 張卡片。</b>
	<br />
	<br />
	<b style="background-color: #f5fa44">*空門Bonus</b>
	<br />
	<b style="background-color: #f5fa44">4位空門者中，將隨機轉盤抽出 1 位獲得2024-25 Mosaic Blaster*1</b>
	<br /> -->
</p-overlayPanel>
